var n,r;function u(){return r?n:(r=1,n=function(n){return function(r){return n.apply(null,r)}})}export{u as __require};
